export const HARD_CODED_CLIENT_PERMISSIONS = {
  permission_id: 10000000,
  name: 'HARD_CODED_CLIENT',
  entity: 'client',
  action: 'can',
  service_type: 'client service'
};

export const HARD_CODED_PARTNER_PERMISSIONS = {
  permission_id: 10000001,
  name: 'HARD_CODED_PARTNER',
  entity: 'partner',
  action: 'can',
  service_type: 'partner service'
};

const abilityMapping = {
  module: {
    view: {
      action: 'view',
      subject: 'module'
    }
  },
  client: {
    can: {
      subject: 'client',
      action: 'can',
    }
  },
  partner: {
    can: {
      subject: 'partner',
      action: 'can',
    }
  },
  profile_billing: {
    view: {
      action: 'view',
      subject: 'profile_billing'
    },
    create: {
      action: 'create',
      subject: 'profile_billing'
    },
    edit: {
      action: 'edit',
      subject: 'profile_billing'
    }
  },
  contract_billing: {
    view: {
      action: 'view',
      subject: 'contract_billing'
    },
    create: {
      action: 'create',
      subject: 'contract_billing'
    },
    terminate: {
      action: 'terminate',
      subject: 'contract_billing'
    }
  },
  bill_billing: {
    view: {
      action: 'view',
      subject: 'bill_billing'
    },
    create: {
      action: 'create',
      subject: 'bill_billing'
    },
    edit: {
      action: 'edit',
      subject: 'bill_billing'
    },
    finalize: {
      action: 'finalize',
      subject: 'bill_billing'
    },
    generate: {
      action: 'generate',
      subject: 'bill_billing'
    }
  },
  omniful_billing_account: {
    view: {
      action: 'view_billing_accounts',
      subject: 'omniful_bill_billing'
    },
    create: {
      action: 'edit_billing_accounts',
      subject: 'omniful_bill_billing'
    },
  },
  tenant_billing_account: {
    view: {
      action: 'view_billing_accounts',
      subject: 'tenant_bill_billing'
    },
    create: {
      action: 'edit_billing_accounts',
      subject: 'tenant_bill_billing'
    },
  },
  adhoc: {
    view: {
      action: 'view',
      subject: 'adhoc'
    },
    create: {
      action: 'create',
      subject: 'adhoc'
    }
  },
  usage_adhoc: {
    view: {
      action: 'view',
      subject: 'usage_adhoc'
    },
    create: {
      action: 'create',
      subject: 'usage_adhoc'
    }
  },
  city_mapping: {
    view: {
      action: 'view',
      subject: 'city_mapping'
    },
    create: {
      action: 'create',
      subject: 'city_mapping'
    },
    edit: {
      action: 'edit',
      subject: 'city_mapping'
    },
    delete: {
      action: 'delete',
      subject: 'city_mapping'
    }
  },
  shipping_partner_city_mapping: {
    view: {
      action: 'view',
      subject: 'shipping_partner_city_mapping'
    },
    create: {
      action: 'create',
      subject: 'shipping_partner_city_mapping'
    }
  },
  sales_channel_city_mapping: {
    view: {
      action: 'view',
      subject: 'sales_channel_city_mapping'
    },
    create: {
      action: 'create',
      subject: 'sales_channel_city_mapping'
    }
  },
  city: {
    view: {
      action: 'view',
      subject: 'city'
    },
    create: {
      action: 'create',
      subject: 'city'
    },
    edit: {
      action: 'edit',
      subject: 'city'
    },
    delete: {
      action: 'delete',
      subject: 'city'
    }
  },
  state: {
    view: {
      action: 'view',
      subject: 'state'
    },
    create: {
      action: 'create',
      subject: 'state'
    },
    edit: {
      action: 'edit',
      subject: 'state'
    },
    delete: {
      action: 'delete',
      subject: 'state'
    }
  },
  country: {
    view: {
      action: 'view',
      subject: 'country'
    },
    create: {
      action: 'create',
      subject: 'country'
    },
    edit: {
      action: 'edit',
      subject: 'country'
    },
    delete: {
      action: 'delete',
      subject: 'country'
    }
  },
  tenant: {
    view: {
      action: 'view',
      subject: 'tenant'
    },
    create: {
      action: 'create',
      subject: 'tenant'
    },
    edit: {
      action: 'edit',
      subject: 'tenant'
    }
  },
  seller: {
    view: {
      action: 'view',
      subject: 'seller'
    },
    create: {
      action: 'create',
      subject: 'seller'
    }
  },
  sku: {
    view: {
      action: 'view',
      subject: 'sku'
    },
    create: {
      action: 'create',
      subject: 'sku'
    }
  },
  hub: {
    view: {
      action: 'view',
      subject: 'hub'
    },
    create: {
      action: 'create',
      subject: 'hub'
    },
    edit: {
      action: 'edit',
      subject: 'hub'
    },
    delete: {
      action: 'delete',
      subject: 'hub'
    }
  },
  omniful_user: {
    view: {
      action: 'view',
      subject: 'omniful_user'
    },
    create: {
      action: 'create',
      subject: 'omniful_user'
    },
    edit: {
      action: 'edit',
      subject: 'omniful_user'
    }
  },
  omniful_role: {
    view: {
      action: 'view',
      subject: 'omniful_role'
    },
    create: {
      action: 'create',
      subject: 'omniful_role'
    },
    edit: {
      action: 'edit',
      subject: 'omniful_role'
    }
  },
  sales_channel_app: {
    view: {
      action: 'view',
      subject: 'sales_channel_app'
    },
    add: {
      action: 'add',
      subject: 'sales_channel_app'
    },
    edit: {
      action: 'edit',
      subject: 'sales_channel_app'
    },
  },
  shipping_app: {
    view: {
      action: 'view',
      subject: 'shipping_app'
    },
    add: {
      action: 'add',
      subject: 'shipping_app'
    },
  },
  pricing_plans: {
    view: {
      action: 'view',
      subject: 'pricing_plan'
    },
    create: {
      action: 'create',
      subject: 'pricing_plan'
    },
  }
};

export default abilityMapping;
